import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { StatsSection } from './components/sections/StatsSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { GallerySection } from './components/sections/GallerySection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { OfferSection } from './components/sections/OfferSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink antialiased" data-id="element-0" data-mp="3mkhm3t5g125i">
      <noscript data-id="element-1" data-mp="3rbrcivytg9ig">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3rdarmj8qkein" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="2zllen0i82im7" />
      <main data-id="element-4" data-mp="2zm4wyibsb90r">
        <StatsSection data-id="element-5" data-mp="2zmo4r67q0h12" />
        <ProblemSection data-id="element-6" data-mp="2zn6bwxvx8fnr" />
        <SolutionSection data-id="element-7" data-mp="33mf25srr5vek" />
        <GallerySection data-id="element-8" data-mp="33nq6btp41567" />
        <VolumesSection data-id="element-9" data-mp="33n6wz1dizp3s" />
        <BonusesSection data-id="element-10" data-mp="33oi1j3esp0vy" />
        <AudienceSection data-id="element-11" data-mp="38l8idsyfc0if" />
        <ComparisonSection data-id="element-12" data-mp="38kqgafp2ys2l" />
        <OfferSection data-id="element-13" data-mp="38kgnylgkc8tq" />
        <FaqSection data-id="element-14" data-mp="3dkuws5pznmst" />
        <FinalCtaSection data-id="element-15" data-mp="3dle3sre3oqs2" />
      </main>
      <SiteFooter data-id="element-16" data-mp="3dmfozootytni" />
      <PurchasePopup data-id="element-17" data-mp="3diry6xarslch" />
    </div>;
}